/** Shopify CDN: Minification failed

Line 61:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 62:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 63:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 68:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 82:49 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 82:79 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 83:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 93:2 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 49:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 50:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 51:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 56:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 70:49 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 70:79 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 71:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 81:2 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 37:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 44:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 58:49 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 58:79 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 59:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 69:2 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 25:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 26:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 27:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 46:49 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 46:79 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 47:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 57:2 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 13:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 14:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 15:0 Transforming const to the configured target environment ("es5") is not supported yet
Line 20:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 34:49 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 34:79 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 35:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 45:2 Transforming const to the configured target environment ("es5") is not supported yet

**/
const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

window.addEventListener('DOMContentLoaded', () => initializeScrollAnimationTrigger());

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
